import React, { useContext, Fragment} from 'react';
import { TabList } from 'Components/commonComponents';
import { LooksList, Products, Makeups, CustomMakeups } from '../SelectionPanel';
import { tabs } from '../../../configuration/ProductsTab';
import {
  FRESH_LENS_TAB,
  LOOKS_TAB,
  MAKEUP_TAB,
  LANG_JP,
  language,
  CLASSIC_LENS_TAB,
} from 'Root/constants';
import content from 'Content/content.json';
import VMContext from '../context';
import { ClickLayer } from '../../../ga4';

const data = content['data'];
const looks = data['looks'];

import './ProductsTab.scss';

const ProductsTab = ({ recommendation }) => {
  const vmContext = useContext(VMContext);
  const {
    onTabClick,
    selectedTab,
    handleLensChange,
    selectedLensType,
    recommendedLensType,
    VMImageLoaded,
    resetSelectedMakeup,
    handleLooksChange,
    looksLoaded,
    currentLookIndex,
    handleShadeChange,
    selectedMakeup,
    handleMakeUpCategoryChange,
    isLensTab,
  } = vmContext;
  const onSelect = (e) => {
    ClickLayer('selecttab');
    onTabClick(e);
  };
  // showing recommended lens only for classic lens type
  const lensRecommended =
    ((selectedTab === recommendedLensType) && recommendation > -1) ? recommendation : -1;
  return (
    <Fragment>
      {isLensTab(selectedTab) && (
        <Products
          selectedTab={selectedTab}
          handleLensChange={handleLensChange}
          recommendedIndex={lensRecommended}
          VMImageLoaded={VMImageLoaded}
          resetSelectedMakeup={resetSelectedMakeup}
        />
      )}

      {selectedTab === LOOKS_TAB && (
        <LooksList
          looks={looks}
          selectedLensType={selectedLensType}
          handleLooksChange={handleLooksChange}
          recommendedIndex={recommendation}
          onLooksLoaded={looksLoaded}
          currentLookIndex={currentLookIndex}
        />
      )}
      {selectedTab === MAKEUP_TAB &&
        (language === LANG_JP ? (
          <CustomMakeups
            handleShadeChange={handleShadeChange}
            resetSelectedMakeup={resetSelectedMakeup}
          />
        ) : (
          <Makeups
            handleShadeChange={handleShadeChange}
            selectedMakeup={selectedMakeup}
            onMakeupCategoryChange={handleMakeUpCategoryChange}
          />
        ))}
      <TabList tabs={tabs} onSelect={onSelect} selectedTab={selectedTab}/>
    </Fragment>
  );
};

export default ProductsTab;
